import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useDevLogging } from "@limitless/common/hooks/dev-logging/DevLoggingContext";
import { useCustomer } from "./CustomerHook";
// Set the default state values for each context
const CustomerContext = /*#__PURE__*/createContext({});
export const CustomerContextProvider = ({
  children,
  storageConfig
}) => {
  const hook = useCustomer(storageConfig);
  const {
    stateTracker
  } = useDevLogging();
  const context = useMemo(() => {
    stateTracker.trackState({
      customer: hook.customer
    });
    return {
      ...hook
    };
  }, [hook.customer]);

  // pass the value in provider and return
  return /*#__PURE__*/React.createElement(CustomerContext.Provider, {
    value: context
  }, children);
};
export const useCustomerContext = () => {
  return useContext(CustomerContext);
};
CustomerContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  storageConfig: PropTypes.object
};